import { render, staticRenderFns } from "./UpdatePurchase.vue?vue&type=template&id=23d89c90"
import script from "./UpdatePurchase.vue?vue&type=script&lang=js"
export * from "./UpdatePurchase.vue?vue&type=script&lang=js"
import style0 from "./UpdatePurchase.vue?vue&type=style&index=0&id=23d89c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports